import { APIPath } from '@intigral/constant';
import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../DataDomain';

import { IHttpAdapter } from '../../entity/interface/iHttpAdapter';
import { IBigScreenCmsRepository } from '../../core/repositories/interfaces/iBigScreenCmsRepository';
import { IBigScreenCmsGamesResponse, IBigScreenCmsMoodsResponse } from '../../entity/interface/iBigScreenCmsMoods';

class BigScreenCmsRepository implements IBigScreenCmsRepository {
    private get http(): IHttpAdapter {
        return container.resolve<IHttpAdapter>(DI.UTILS.IHttpAdapter);
    }

    constructor() {}

    async getMoods(): Promise<IBigScreenCmsMoodsResponse> {
        const response = await this.http.get<IBigScreenCmsMoodsResponse>(APIPath.BIGSCREEN_CMS_MOODS);
        return response.data;
    }

    async getGames(): Promise<IBigScreenCmsGamesResponse> {
        const response = await this.http.get<IBigScreenCmsGamesResponse>(APIPath.BIGSCREEN_CMS_STC_PLAY_GAMES);
        return response.data;
    }
}

export default BigScreenCmsRepository;
